import React from 'react'
import { Box } from '@usap/uicomponents'
import { commaSeparetedValue } from '@usap/core'
import { SummaryDarkerItem } from '../SummaryWmo.css'

const HandlingWmo = props => {
  const { data } = props

  return (
    <Box direction="row" justify="between">
      <SummaryDarkerItem>
        Handling:
      </SummaryDarkerItem>

      <SummaryDarkerItem data-testid='cart-summary-handling'>
        $
        {commaSeparetedValue(parseFloat(data.handling.estimated))}
      </SummaryDarkerItem>
    </Box>
  )
}

export default HandlingWmo
